import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: VT323;
    src: url(./fonts/VT323/VT323-Regular.ttf);
  }

  @font-face {
    font-family: Ubuntu;
    src: url(./fonts/Ubuntu/Ubuntu-Bold.ttf);
  }

  @font-face {
    font-family: Montserrat;
    src: url(./fonts/Montserrat/Montserrat-Bold.ttf);
  }

  * {
    user-select: none;
  }

  html {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  
  body {
    font-family: 'VT323', monospace;
    background-color: #769aa7;
    color: #000;
    overflow: hidden;
  }
  
  @media (prefers-color-scheme: dark) {
    body {
      background-color: #292d32; 
    }
  }
  
  p {
    margin: 0;
    padding: 0;
  }
  
  h1, h2, h3, h4, h5, h6 {
    margin-top: 0;
    margin-bottom: 0;
    line-height: 1.2;
  }
  
  .float-left {
    float: left;
  }
  
  .float-right {
    float: right;
  }
  
  .clear-both {
    clear: both;
  }
`

export default GlobalStyles;
